<div *ngIf="auth.isLoggedIn" class="user-profile">
    <div class="col-sm-6 img">
      <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcSS1_an2x9kdsUqcWy2kGMNUMlYXbyf0Sr9896Tx5uXZbNvIc2L&usqp=CAU"  alt="" class="img-rounded">
    </div>
    <div class="col-md-3 details">
      <blockquote>
        <h5>Добро пожаловать, {{auth.user.username}}</h5>
      </blockquote>
      <p>
        {{auth.user.email}}
      </p>
      <button mat-raised-button type="button" (click)="auth.logOut()">Выйти</button>
    </div>
  </div>